import { useStore } from '../../store/useStore';
import { dialogs } from '../../data/dialogs';

export const DialogUI = () => {
    const activeDialog = useStore((state) => state.activeDialog);
    const advanceDialog = useStore((state) => state.advanceDialog);
    const closeDialog = useStore((state) => state.closeDialog);

    if (!activeDialog) return null;

    const dialogData = dialogs[activeDialog.dialogId];
    if (!dialogData) return null;

    const currentStep = dialogData.steps[activeDialog.stepId];
    if (!currentStep) return null;

    const handleOptionClick = (nextStepId: string, action?: () => void) => {
        if (action) action();

        if (nextStepId === 'end') {
            closeDialog();
        } else {
            advanceDialog(nextStepId);
        }
    };

    return (
        <div style={{
            position: 'absolute',
            bottom: '120px', // Moved up
            left: '50%',
            transform: 'translateX(-50%)',
            width: '600px',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            border: '2px solid #fff',
            borderRadius: '10px',
            padding: '20px',
            color: 'white',
            fontFamily: 'monospace',
            zIndex: 1000,
            boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
        }}>
            <h3 style={{ margin: '0 0 10px 0', color: '#ffd700' }}>{activeDialog.npcName}</h3>
            <p style={{ fontSize: '1.2em', lineHeight: '1.5', marginBottom: '20px' }}>{currentStep.text}</p>

            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {currentStep.options?.map((option, index) => (
                    <button
                        key={index}
                        onClick={() => handleOptionClick(option.nextStepId, option.action)}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#333',
                            color: 'white',
                            border: '1px solid #666',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '1em',
                            transition: 'background 0.2s'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#555'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#333'}
                    >
                        {option.label}
                    </button>
                ))}
                {(!currentStep.options || currentStep.options.length === 0) && (
                    <button
                        onClick={closeDialog}
                        style={{
                            padding: '8px 16px',
                            backgroundColor: '#333',
                            color: 'white',
                            border: '1px solid #666',
                            borderRadius: '5px',
                            cursor: 'pointer'
                        }}
                    >
                        Close
                    </button>
                )}
            </div>
        </div>
    );
};
